import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function ForWhom() {
  const items = ['Tenés diabetes tipo 2', 'Tenés prediabetes', 'Tenés resistencia a la insulina', 'No sabés qué podés comer', 'Extrañás las comidas que te gustan', 'Querés recetas simples y prácticas', 'Buscás ingredientes fáciles de conseguir', 'Querés comer rico sin sentirte limitado'];
  return <section className="py-20 md:py-32 px-6 bg-white" data-id="element-42">
      <div className="max-w-4xl mx-auto" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-44">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900" data-id="element-45">
            Esto fue creado especialmente para vos si...
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-4 md:gap-6" data-id="element-46">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-green-50/50 p-6 rounded-2xl flex items-center space-x-4 border border-green-100 hover:bg-green-50 transition-colors" data-id="element-47">
              <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center shadow-sm flex-shrink-0" data-id="element-48">
                <ArrowRight className="w-4 h-4 text-primary" data-id="element-49" />
              </div>
              <span className="text-lg text-gray-800 font-medium" data-id="element-50">{item}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}